<template>
	<div
		class="sponsored-pill text-high bg-medium-active px-1 py-2"
		:class="{ 'stick-to-border': shouldStickToBorder }"
	>
		<div
			data-balloon-pos="down-right"
			data-balloon-blunt
			:aria-label="$t('WEBAPP_NATIVE_RECOMMENDATION_AD_DESCRIPTION_GENERAL')"
			class="tooltip"
		>
			<p class="sponsored-pill__text">{{ $t('WEBAPP_NATIVE_RECOMMENDATION_AD_TITLE') }}</p>
		</div>
	</div>
</template>

<script lang="ts" setup>
defineProps<{ shouldStickToBorder?: boolean }>();
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
@import 'balloon-css/src/balloon';
@import '~@/styles/rtl-support-mixins';

.sponsored-pill {
	display: flex;
	align-items: center;
	position: absolute;
	@include inset-inline('end', 1px);
	top: 1px;

	z-index: 3;
	border-radius: 0 4px 0 20px;

	&.stick-to-border {
		@include inset-inline('end', 0px);
		top: 0px;
	}

	&__text {
		margin: 0;
		font-size: $font-size-small;

		@media (max-width: $screen-xxs) {
			font-size: 10px;
		}

		@container srCompact (max-width: 360px) {
			font-size: 10px;
		}
	}

	.tooltip {
		display: flex;
		align-items: center;
		--balloon-font-size: 14px;
		--balloon-text-color: #2f3841;
		--balloon-border-radius: 3px;
		--balloon-color: #d5d5d5;
		--balloon-font-size: 10px;
		line-height: 14px;

		&:after {
			min-width: 200px;
			padding: 0.5em;
			white-space: normal;

			@media (max-width: $screen-xxxs) {
				min-width: 180px;
			}
		}
	}
}
</style>
